module.exports = __webpack_public_path__ + "assets/img/thumb_ch4_news-item-2.5da0f5fc.jpg";